import { openBlock as t, createElementBlock as l, createElementVNode as e } from "vue";
const o = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
}, n = /* @__PURE__ */ e("path", { d: "m11.741 2.136 2.121 2.122L9.62 8.5 7.498 6.38l4.243-4.243Zm-4.95 4.95 2.122 2.121-7.392 6.048a.553.553 0 0 1-.74-.037M12.448 1.429l2.121 2.121a1 1 0 0 0 0-1.414l-.707-.707a1 1 0 0 0-1.414 0Z" }, null, -1), c = /* @__PURE__ */ e("path", {
  "fill-rule": "evenodd",
  d: "M14.57 3.55a1 1 0 0 0 0-1.414l-.708-.707a1 1 0 0 0-1.414 0l2.121 2.121Z",
  "clip-rule": "evenodd"
}, null, -1), d = [
  n,
  c
];
function r(s, a) {
  return t(), l("svg", o, [...d]);
}
const h = { render: r };
export {
  h as default,
  r as render
};
